import React from 'react';

/**
 * CTA overlay for empty Client Reporting widgets — sits above a demo preview
 * so visitors see what the dashboard could look like after linking a broker.
 */
export default function ClientReportingConnectPrompt({
  badge = 'Demo preview',
  title = 'Connect a brokerage',
  message = 'Link an account to see your real equity curve, holdings breakdown, and portfolio performance here.',
  actionLabel = 'Add / Sync Trades',
  onAction,
  compact = false,
}) {
  return (
    <div className={`vd-cr-connect-prompt${compact ? ' vd-cr-connect-prompt-compact' : ''}`}>
      {badge ? <span className="vd-cr-demo-badge">{badge}</span> : null}
      {title ? <h4 className="vd-cr-connect-prompt-title">{title}</h4> : null}
      {message ? <p className="vd-cr-connect-prompt-message">{message}</p> : null}
      {onAction ? (
        <button type="button" className="vd-btn vd-client-sync-btn" onClick={onAction}>
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
